const ENABLED = 'Enabled';
const DISABLED = null;

export default {

	//	Maximum number of stocks stored to local storage
	maxRecent: 10,

	/** Whitelist for different securities types to consider for local storage
	*	 Toggle below to allow
	*/
	allowedInStorage: {
		COMMODITY: DISABLED,
		CURRENCY: ENABLED,
		FUND: ENABLED,
		FUTURE: DISABLED,
		INDEX: DISABLED,
		INTEREST: DISABLED,
		MISC: DISABLED,
		NOTE: DISABLED,
		OPTION: DISABLED,
		RIGHTS: DISABLED,
		SECTOR: DISABLED,
		STATISTIC: DISABLED,
		STOCK: ENABLED,
		TEST: DISABLED,
		UNKNOWN: DISABLED,
		WARRANT: DISABLED
	 }
};
